const SESSION_EXPIRED_EVENT = 'session-expired';

// Endpoints that legitimately return 401 without meaning the session is expired
// (e.g. the auth check itself on initial load)
const IGNORED_PATHS = ['/api/auth/me', '/api/auth/google'];

let interceptorInstalled = false;

export function installFetchInterceptor() {
  if (interceptorInstalled) return;
  interceptorInstalled = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async function interceptedFetch(input, init) {
    const url = typeof input === 'string' ? input : input?.url ?? '';
    const response = await originalFetch(input, init);

    if (response.status === 401 && !IGNORED_PATHS.some(p => url.includes(p))) {
      window.dispatchEvent(new CustomEvent(SESSION_EXPIRED_EVENT));
    }

    return response;
  };
}
